export default __webpack_public_path__ + "static/media/MOTIVO_13.eeafd50a.jpg";